import { TReview } from '@/domain/Reviews.domain';
import { RatingStars } from '../AttractionsContent/core/RatingStars';
import { Commas } from '@/ui/common/Icons/Commas';

type TReviewCardProps = {
    item: TReview;
};

export const ReviewCard = ({ item: { title, rate, time, content, user } }: TReviewCardProps) => {
    return (
        <div
            data-test-id="review-card"
            className="tx-large-regular relative max-w-full overflow-hidden rounded-2xl bg-white p-[20px_22px_60px] text-gray-2 shadow-lightCard dark:bg-dark-3 dark:text-gray-3 dark:shadow-dark md:pb-[70px]"
        >
            <span
                data-test-id="review-title"
                className=" tx-large-medium mb-4 block w-[90%] overflow-hidden text-ellipsis whitespace-nowrap text-brand"
            >
                {title}
            </span>
            <div
                data-test-id="review-time"
                className="tx-large-medium mb-1 flex items-center text-gray-1 dark:text-white"
            >
                <RatingStars rating={rate} className=" mr-2" count={rate} />
                {time}
            </div>
            {content}
            <span
                data-test-id="review-user"
                className=" tx-large-semibold absolute bottom-5 right-5 flex w-full justify-end text-gray-1 dark:text-white"
            >
                {user}
            </span>
            <Commas className=" absolute right-6 top-6 md:top-7 [&>*]:dark:fill-blue-1" />
        </div>
    );
};
